// extracted by mini-css-extract-plugin
module.exports = {"postContainer":"myProject_postContainer__9uiwq","cardContainer":"myProject_cardContainer__3Wdxs","cardList":"myProject_cardList__3OSkM"};